import { AppRemixIcon } from '@/layout/AppComponents';
import CustomStateIcon from '../layout/components/helpers/CustomStateIcon';

export const stateColor = (stateCode, customState = null) => {
  switch (stateCode) {
    case -1:
      return 'repeating-linear-gradient(-45deg,white,white 4px,#e8e8d5 4px,#e8e8d5 10px)';
    case 0:
      return '#e8e8d5';
    case 1:
      return '#48b363';
    case 2:
      return '#e7a163';
    case 3:
      return '#e04040';
    case 4:
      return '#878787';
    case 5:
      return '#333333';
    case 6:
      return customState ? customState.bgColor : '';
    case 'error':
      return 'red';
    default:
      return 'white';
  }
};

export const stateIcon = (stateCode, customState = null) => {
  switch (stateCode) {
    case -1:
      return <AppRemixIcon icon="history" color="#003d47" />;
    case 0:
      return <AppRemixIcon icon="file" color="#003d47" />;
    case 1:
      return <AppRemixIcon icon="check" color="white" />;
    case 2:
      return <AppRemixIcon icon="settings-5" color="white" />;
    case 3:
      return <AppRemixIcon icon="spam-3" color="white" />;
    case 4:
      return <AppRemixIcon icon="eye-off" color="white" />;
    case 5:
      return <AppRemixIcon icon="delete-bin" color="white" />;
    case 6:
      return customState ? (
        <CustomStateIcon
          icon={customState.icon}
          color={customState.fgColor}
          type={customState.iconType}
        />
      ) : (
        ''
      );
    case 'error':
      return <AppRemixIcon icon="alert" color="white" />;
    // case 5: return '#e8e8d5';
    default:
      return '...';
  }
};
